<script>
  import {
    setContext,
    createEventDispatcher,
    onDestroy,
    onMount,
  } from "svelte";
  import { validationStore } from "../../stores/General";
  import { isEqual } from "lodash";
  export let rules = {};
  $: data = {};

  let form;
  let originalData = null;
  const dispatch = createEventDispatcher();
  const { errors, isValid, isChanged, resetValidation } = validationStore;

  function onFormChange(e) {
    const value = e.target?.value || e.detail || e.srcElement?.files[0];
    const name = e.target?.name || e.name || e.srcElement?.name || null;
    if (name) data[name] = value;

    validateForm();
  }

  // returns isError: true | false
  async function validateField(field) {

    if (field in rules) {
      const value = data[field];
      for (const validateWithFn of rules[field].validators) {
        const message = await validateWithFn(value);
        if (message) {
          errors.update((e) => {
            e[field] = message;
            return e;
          });
          isValid.update(() => false);
          return false;
        }
      }
      errors.update((e) => {
        e[field] = null;
        return e;
      });
    }
    return true;
  }
  const detectChanges = (obj) => {
    if (!originalData) return false;
    const changed = !isEqual(originalData, obj);
    isChanged.update(() => changed);
  };
  async function validateForm() {
    let validated = [];
    detectChanges(data);
    for (const key in data) {
      validated.push(validateField(key));
    }
    const complete = await Promise.all(validated);
    isValid.update(() => complete.every((test) => test));
  }

  function updateData(init = false) {
    const formData = new FormData(form);
    // fetch all fields from the form
    data = {};
    for (let field of formData) {
      // if video file get form file store the file in the data object with formData.get(input_name)
      const [key, value] = field;
      if (value) {
        try {
          data[key] = JSON.parse(value);
        } catch {
          data[key] = value;
        }
      } else {
        if (!init) data[key] = value;
      } 
    }
    if (init) {
      originalData = { ...data };
    }
    detectChanges(data);
  }

  function onSubmit() {
    return dispatch("submit", { valid: $isValid, data });
  }
  onMount(() => {
    resetValidation();
    updateData(true);
    //validateForm();
  });

  export function reset() {
    form.reset();
  }
  function getForm(){
    return form
  }

  setContext("form", {
    onFormChange,
    errors,
    isValid,
    rules,
    getForm
  });
  onDestroy(reset);
</script>

<form class="space-y-8" on:submit|preventDefault={onSubmit} bind:this={form}>
  <div class="space-y-8 sm:space-y-5">
    <slot />
  </div>
</form>
